const LOAD_TOKENS = "[session][tokens]load.tokens"
const SAVE_TOKENS = "[session][tokens]save.tokens"
const DISCARD_TOKENS = "[session][tokens]discard.tokens"

export {LOAD_TOKENS, SAVE_TOKENS, DISCARD_TOKENS}